/**
 * Shared blob-URL cache for attachment previews.
 * Prevents re-downloading the same file across multiple mounted galleries
 * (e.g. Styles list thumbnails + open detail modal).
 */
import { api } from "@/lib/api";

const cache = new Map(); // id => { url, refCount, promise }

export async function attachmentBlobUrl(id) {
  const hit = cache.get(id);
  if (hit) {
    hit.refCount += 1;
    if (hit.url) return hit.url;
    if (hit.promise) return hit.promise;
  }
  const entry = { refCount: 1, url: null, promise: null };
  cache.set(id, entry);
  entry.promise = (async () => {
    try {
      const r = await api.get(`/attachments/${id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      entry.url = url;
      return url;
    } catch (e) {
      cache.delete(id);
      return null;
    }
  })();
  return entry.promise;
}

export const attachmentPreviewUrl = {
  release(url) {
    // Only revoke when nothing else is using it. For simplicity we keep
    // the URL alive; browsers reclaim on unload. This trades a tiny amount
    // of memory for the shared-cache benefit.
    void url;
  },
};

export function bulkPrimaryMap(list) {
  const m = {};
  for (const a of list) m[a.entity_id] = a;
  return m;
}

export async function fetchPrimaryAttachments(entity, entityIds) {
  if (!entityIds?.length) return [];
  try {
    const r = await api.get("/attachments-primary", {
      params: { entity, entity_ids: entityIds.join(",") },
    });
    return r.data;
  } catch {
    return [];
  }
}
